// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__gypRN","footer":"Form_footer__L7F2Q"};